/* All possible appraisal statuses from Merch pricing aggregates:
  As defined here: https://carvanadev.visualstudio.com/Carvana.Merch/_git/Carvana.Search.API?path=/Carvana.Search.API.Contracts/TradesResponse.cs&version=GBmaster&_a=contents 
*/
export enum TradeInStatus {
  Active = 'active',
  Completed = 'completed',
  Deleted = 'deleted',
  Expired = 'expired',
  NotSet = 'notset',
  Rejected = 'rejected',
  Unclaimed = 'unclaimed'
}
